module.exports = __webpack_public_path__ + "media/images/official/plancheck_chart_pc-4d1b8a1c8fd2d3c5baa3e48268e76cad.jpg";